<button type="button" class="btn-kendo-grid-refresh">
  <i class="fal fa-sync"></i>
</button>
